module.exports = __webpack_public_path__ + "img/CanvasEco.03764903.jpg";